import { StreamDashboardComponent } from './home/user/stream-dashboard/stream-dashboard.component';
import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from './start/login-form/login-form.component';
import { PwForgottenComponent } from './start/pw-forgotten/pw-forgotten.component';
import { RegisterComponent } from './start/register/register.component';
import { PwSetnewComponent } from './start/pw-setnew/pw-setnew.component';
import { ConfirmEmailComponent } from './start/confirm-email/confirm-email.component';
import { TwoFactorauthComponent } from './start/two-factorauth/two-factorauth.component';
import { PrivacyComponent } from './view/privacy/privacy.component';
import { ImprintComponent } from './view/imprint/imprint.component';
import { AllcomponentsComponent } from './view/allcomponents/allcomponents.component';
import { TermsComponent } from './view/terms/terms.component';
import { HomeComponent } from './home/home.component';
import { AuthGuardService } from './service/auth.guard.service';
import { UseraccountComponent } from './home/user/useraccount/useraccount.component';
import { FaqComponent } from './view/faq/faq.component';
import { PromotionComponent } from './start/promotion/promotion.component';
import { InternLandingPageComponent } from './components-track/intern-landing-page/intern-landing-page.component';
import { MentorComponent } from './home/mentor/mentor.component';
import { StartupNavigatorComponent } from './home/mentor/startup-navigator/startup-navigator.component';
import { GenericStreamDashboardComponent } from './home/user/generic-stream-dashboard/generic-stream-dashboard.component';
import { GenericStreamComponent } from './home/user/generic-stream/generic-stream.component';
import { GenericResultScreenComponent } from './home/user/generic-stream/generic-result-screen/generic-result-screen.component';
import { CongratSignupComponent } from './start/congrat-signup/congrat-signup.component';
import { GenericHtmlViewStandaloneComponent } from './home/user/generic-stream/generic-html-view-standalone/generic-html-view-standalone.component';
import { CongratResetpwLinkSentComponent } from './start/congrat-resetpw-link-sent/congrat-resetpw-link-sent.component';
import { MobileCheckGuard } from './service/mobile-check.guard';
import { ShortRegistrationComponent } from './start/short-registration/short-registration.component';
import { MentorGuardService } from './service/mentor.guard.service';
import { ConfirmDeletionComponent } from './start/confirm-deletion/confirm-deletion.component';
import { RejectDeletionComponent } from './start/reject-deletion/reject-deletion.component';
import { AwaitingAccessFromCoachComponent } from './start/awaiting-access-from-coach/awaiting-access-from-coach.component';

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    // scrollOffset: [0, 64]
};

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'start', redirectTo: 'login', pathMatch: 'full' },
    // { path: 'start', component: StartComponent },
    { path: 'promotion/:promotionId', component: PromotionComponent },
    { path: 'projectpage', component: InternLandingPageComponent },
    {
        path: 'generic-stream/published/:any',
        component: GenericHtmlViewStandaloneComponent,
    },
    {
        path: 'generic-stream/editable/:any',
        canActivate: [AuthGuardService],
        component: GenericHtmlViewStandaloneComponent,
    },
    {
        path: 'login',
        children: [
            { path: '', component: LoginFormComponent },
            { path: 'resetpassword', component: PwForgottenComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'congrat-signup', component: CongratSignupComponent },
            { path: 'awaiting-access', component: AwaitingAccessFromCoachComponent },
            {
                path: 'password-forgotten-sent',
                component: CongratResetpwLinkSentComponent,
            },
            { path: 'short-registration', component: ShortRegistrationComponent },
            { path: ':id', component: LoginFormComponent },
            { path: 'set-new-password/:resetid', component: PwSetnewComponent },
            { path: 'confirm/:confirmid', component: ConfirmEmailComponent },
            { path: 'verify/:verifyId', component: TwoFactorauthComponent },
        ],
    },
    {
        path: 'home',
        canActivate: [AuthGuardService, MobileCheckGuard],

        component: HomeComponent,
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'start', redirectTo: "login", pathMatch: 'full' },
            // { path: 'start', component: StartComponent },
            { path: 'promotion/:promotionId', component: PromotionComponent },
            { path: 'projectpage', component: InternLandingPageComponent },
            { path: 'generic-stream/published/:any', component: GenericHtmlViewStandaloneComponent },
            {
                path: 'generic-stream/editable/:any',
                canActivate: [AuthGuardService],
                component: GenericHtmlViewStandaloneComponent
            },
            { path: 'user', component: GenericStreamDashboardComponent },
            //   { path: 'user', component: StreamDashboardComponent },
            {
                path: 'user/account',
                component: UseraccountComponent,
            },
            {
                path: 'mentor',
                component: MentorComponent,
                canActivate: [MentorGuardService],
                children: [
                    { path: '', component: StartupNavigatorComponent },
                    { path: 'dashboard', component: StartupNavigatorComponent },
                ],
            },
        ],
    },
    {
        path: 'generic-stream/:id',
        component: GenericStreamComponent,
        canActivate: [AuthGuardService, MobileCheckGuard],
    },
    {
        path: 'generic-stream/result/:id',
        component: GenericResultScreenComponent,
        canActivate: [AuthGuardService, MobileCheckGuard],
    },
    { path: 'deletion/confirm/:confirmId', component: ConfirmDeletionComponent, canActivate: [AuthGuardService, MobileCheckGuard] },
    { path: 'deletion/reject/:confirmId', component: RejectDeletionComponent, canActivate: [AuthGuardService, MobileCheckGuard] },

    { path: 'privacy', component: PrivacyComponent },
    { path: 'imprint', component: ImprintComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'faq', component: FaqComponent },
    // New Track Run
    // All Components 4 you :-)
    { path: 'ac4u', component: AllcomponentsComponent },
    // Fallback
    { path: '**', redirectTo: 'start' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule { }

//! ROUTING IST WEG???
